// user.reducer.ts
import { createReducer, on } from '@ngrx/store';
import authActions from './auth.actions';

export interface AuthState {
  token: string | null;
  user:any | null
}

export const initialAuthState: AuthState = {
  token: null,
  user:null
};

export const authReducer = createReducer(
  initialAuthState,
  on(authActions.setToken, (state, { token }) => {

    localStorage.setItem('token', JSON.stringify(token));

    return ({ ...state, token });
  }),
  on(authActions.clearToken, (state) => {

    localStorage.removeItem('token');

    return ({ ...state, token: null });
  }),
  on(authActions.setUser, (state, { user }) => {
    
    localStorage.setItem('user', JSON.stringify(user));

    return ({ ...state, user });
  }),
  on(authActions.clearUser, (state) => {
   
    localStorage.removeItem('user');

    return ({ ...state, userData: null });
  })
);
